import { css } from '@emotion/react';
import { Text } from '../../text';
import { AccordionStyles } from '../common-styles';

type DefaultAccordionHeaderProps = {
  title?: string;
  subtitle?: string;
};

export const DefaultAccordionHeader = ({ title, subtitle }: DefaultAccordionHeaderProps) => {
  const titleStyle = AccordionStyles.defaultAccordionHeader({
    defaultHeader: 'title',
    hasSubtitle: !!subtitle,
  });
  const subtitleStyle = AccordionStyles.defaultAccordionHeader({
    defaultHeader: 'subtitle',
  });

  return title || subtitle ? (
    <section
      css={css`
        display: flex;
        flex-direction: column;
        text-align: left;
      `}
    >
      {!!title && (
        <Text as='span' css={titleStyle}>
          {title}
        </Text>
      )}
      {!!subtitle && <Text css={subtitleStyle}>{subtitle}</Text>}
    </section>
  ) : null;
};
